import { Calendar } from "components/ui/calendar";
import { Label } from "components/ui/label";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { CalendarIcon } from "lucide-react";
import { useEffect, useState } from "react";

interface SingleDatePickerProps {
  id?: string;
  date?: Date;
  onDateChange?: (date: Date | undefined) => void;
  label?: string;
}

function SingleDatePicker({
  id,
  date: initialDate,
  onDateChange,
  label,
}: SingleDatePickerProps) {
  const [date, setDate] = useState<Date | undefined>(initialDate);
  const [isOpen, setIsOpen] = useState(false);
  const [month, setMonth] = useState(initialDate || new Date());

  useEffect(() => {
    setDate(initialDate);
    setMonth(initialDate || new Date());
  }, [initialDate]);

  const handleSelect = (selectedDate: Date | undefined) => {
    setDate(selectedDate);
    setMonth(selectedDate || new Date());
    if (onDateChange) {
      onDateChange(selectedDate);
    }
    setIsOpen(false);
  };

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <Label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </Label>
      )}
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <button
            id={id}
            className="flex items-center w-full h-[50px] px-4 py-2 border rounded-lg text-left text-gray-700 shadow-sm"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="flex-1">
              {date
                ? format(date, "dd/MM/yyyy", { locale: ptBR })
                : "Selecione uma data"}
            </span>
            <CalendarIcon className="text-gray-500 w-5 h-5 ml-2" />
          </button>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto p-0 z-[9999]"
          align="start"
          side="bottom"
          sideOffset={8}
        >
          {" "}
          <Calendar
            initialFocus
            mode="single"
            selected={date}
            onSelect={handleSelect}
            month={month}
            onMonthChange={setMonth}
            locale={ptBR}
            fromYear={2000}
            disabled={() => false}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}

export default SingleDatePicker;
